import { FormCrud } from "components/Form/hooks"
import { createAffiliationHooks } from ".."
import { useSelector } from "react-redux"
import { alerts as alertKeys } from 'keys'

const AffliationData = () => {
    const formName = "createAffliation"
    const { actionSubmit } = FormCrud()
    const { alerts, updateRoleIsPending } = useSelector(state => state.general)

    const setAlert = createAffiliationHooks.useAlert()

    const affiliationExist = alerts[alertKeys.createAffliation].props?.id

    const submitBtns = [
        {
            id: 0,
            label: "ביטול",
            color: "light",
            variant: "white",
            action: () => setAlert(false)
        },
        {
            id: 1,
            label: affiliationExist ? "עדכון" : "הוספה",
            color: "secondary",
            variant: "regular",
            action: () => actionSubmit(formName)
        },
    ]

    return submitBtns
}

export default AffliationData